import { TreeDataItem } from 'components/FilesTree/types'
import { makeAutoObservable } from 'mobx'

import { type RootStore } from 'stores/RootStore'
import { AlmanacFile } from 'types'

export class WorkspaceTemplatesStore {
  rootStore: RootStore
  selectedFile: TreeDataItem | null = null
  destinationFolder?: AlmanacFile | null = null
  openedTemplateDropdownFileId?: string | null = null
  searchQuery?: string = ''
  newItemPosition?: number | null = null

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore
    makeAutoObservable(this)
  }

  setSelectedFile(selectedFile: TreeDataItem | null) {
    this.selectedFile = selectedFile
  }

  setSearchQuery(searchQuery?: string) {
    this.searchQuery = searchQuery
  }

  setDestinationFolder(destinationFolder?: AlmanacFile | null) {
    this.destinationFolder = destinationFolder
  }

  setOpenedTemplateDropdownFileId(openedTemplateDropdownFileId?: string | null) {
    this.openedTemplateDropdownFileId = openedTemplateDropdownFileId
  }

  setNewItemPosition(newItemPosition?: number | null) {
    this.newItemPosition = newItemPosition
  }

  cleanup = () => {
    this.selectedFile = null
    this.newItemPosition = null
    this.searchQuery = undefined
  }
}
